import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useUserUpdates } from "~context/UserUpdatesContext/UserUpdatesContext.tsx";
import { useApi } from "~hooks/apiHooks/useApi/useApi.ts";
import { useNotification } from "~hooks/useNotification";
import type { Notification, NotificationResponse } from "~types/notification.ts";

export const useMarkAsReadNotification = () => {
  const { formatMessage } = useIntl();
  const queryClient = useQueryClient();
  const request = useApi();
  const notification = useNotification();
  const { refetch: refetchUserUpdates } = useUserUpdates();

  return useMutation<NotificationResponse, Error, string>({
    mutationFn: async (key: string) => {
      return await request(`notifications/${key}/mark-as-read`, {
        method: "POST",
      });
    },
    onSuccess: (response: NotificationResponse, key: string) => {
      if (response?.data && response.data.length > 0) {
        queryClient.setQueryData(["notifications"], (oldNotifications: Notification[]) =>
          (oldNotifications || []).map((oldNotification: any) => (oldNotification.key === key ? response.data[0] : oldNotification)),
        );
        queryClient.invalidateQueries({ queryKey: ["user", "updates"] });
        refetchUserUpdates();
        notification.success({
          message: formatMessage({
            id: "notificationsPage.markAsRead.success",
          }),
          placement: "bottomRight",
        });
      }
    },
  });
};
